module.exports = __webpack_public_path__ + "img/14.87c6ac1d.jpeg";